const { Core } = Global;


const CN_LOADING = '!loading';
const ATTR_VARIANT_ID = 'variant-id';


customElements.define('product-to-cart', class extends Core {
    elements = {
        $: ['to-cart-button']
    }


    propTypes = {
        'form-child': Boolean
    }


    render() {
        this.$({ click: this._onClick });
    }


    _onClick(e) {
        e.preventDefault();
        this.loading = true;


        // Try to find the quantity input inside the closest product form
        let quantity = 1;
        const form = this.closest('form');
        if (form) {
            const qtyInput = form.querySelector('input[name="quantity"]');
            if (qtyInput && qtyInput.value) {
                const parsedQty = parseInt(qtyInput.value, 10);
                if (!isNaN(parsedQty) && parsedQty > 0) {
                    quantity = parsedQty;
                }
            }
        }


        // Build product payload with selected quantity
        const payload = {
            id: this.variantId,
            quantity: quantity
        };


        // Send AJAX request directly without triggering CART_UPDATE events
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
        })
        .then(() => {
            this.loading = false;
            window.location.href = '/cart'; // Redirect immediately
        })
        .catch(err => {
            console.error(err);
            this.loading = false;
        });
    }


    set loading(state) {
        this.$('to-cart-button').classList.toggle(CN_LOADING, state);
    }


    set variantId(id) {
        this.setAttribute(ATTR_VARIANT_ID, id);
    }


    get variantId() {
        return +this.getAttribute(ATTR_VARIANT_ID);
    }
});